/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_New_Password_PlaceholderInputs */

const en_common_sign_new_password_placeholder = /** @type {(inputs: Common_Sign_New_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your new password`)
};

const zh_common_sign_new_password_placeholder = /** @type {(inputs: Common_Sign_New_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入新密码`)
};

/**
* | output |
* | --- |
* | "Enter your new password" |
*
* @param {Common_Sign_New_Password_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_new_password_placeholder = /** @type {((inputs?: Common_Sign_New_Password_PlaceholderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_New_Password_PlaceholderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_new_password_placeholder(inputs)
	return zh_common_sign_new_password_placeholder(inputs)
});
export { common_sign_new_password_placeholder as "common.sign.new_password_placeholder" }